import filter from './filter';
import Observable from './observable';
export default function distinct(comparator, stream) {
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return Observable.defer(function factory() {
        let currentValue = undefined;
        return filter(
        // tslint:disable-next-line:ter-prefer-arrow-callback
        function distinctFilter(value, index) {
            const previousValue = currentValue;
            currentValue = value;
            return index === 0 ? true : comparator(value, previousValue);
        }, stream);
    });
}
//# sourceMappingURL=distinct.js.map